import { cn } from '@components/shadcn/utils';
import { SVGProps } from 'react';

interface ChevronProps extends Readonly<SVGProps<SVGSVGElement>> {}

export const BaseChevronIcon = ({ fill = '#696F88', ...props }: ChevronProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      {...props}
      className={cn('inline-block', props.className)}
    >
      <path
        d="M7.27869 4.5L6.22119 5.5575L9.65619 9L6.22119 12.4425L7.27869 13.5L11.7787 9L7.27869 4.5Z"
        fill={fill}
      />
    </svg>
  );
};

export const ChevronRightIcon = (props: ChevronProps) => {
  return <BaseChevronIcon {...props} />;
};

export const ChevronDownIcon = (props: ChevronProps) => {
  return <BaseChevronIcon {...props} className={cn('rotate-90', props.className)} />;
};

export const ChevronLeftIcon = (props: ChevronProps) => {
  return <BaseChevronIcon {...props} className={cn(props.className, 'rotate-180')} />;
};
